import loadingReducer, { setLoading } from './_loading';
import dialogReducer, { setDialog, setOptions } from './_dialog';
import metaReducer, { setData } from './_meta';
import routerReducer, { setCurrentRoute } from './_router';

export const sliceActions = {
  setLoading,
  setDialog,
  setOptions,
  setData,
  setCurrentRoute,
};

export default {
  loading: loadingReducer,
  dialog: dialogReducer,
  meta: metaReducer,
  router: routerReducer,
};
